// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-contacts-indexstyleGrid-container-kukya{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-company-contacts-indexstyleGrid-grid-bagmb{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-company-contacts-indexstyleGrid-col6-buhok{grid-column:span 6}.pages-company-contacts-indexstyleGrid-col3-bocnv{grid-column:span 3}.pages-company-contacts-indexstyleGrid-col4-zwuow{grid-column:span 4}.pages-company-contacts-indexstyleGrid-col9-hwwnf{grid-column:span 9}.pages-company-contacts-indexstyleGrid-col12-bjkxp{grid-column:span 12}.pages-company-contacts-indexstyleGrid-alignItemsStart-bvtfg{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-company-contacts-indexstyleGrid-container-kukya",
	"grid": "pages-company-contacts-indexstyleGrid-grid-bagmb",
	"col6": "pages-company-contacts-indexstyleGrid-col6-buhok",
	"col3": "pages-company-contacts-indexstyleGrid-col3-bocnv",
	"col4": "pages-company-contacts-indexstyleGrid-col4-zwuow",
	"col9": "pages-company-contacts-indexstyleGrid-col9-hwwnf",
	"col12": "pages-company-contacts-indexstyleGrid-col12-bjkxp",
	"alignItemsStart": "pages-company-contacts-indexstyleGrid-alignItemsStart-bvtfg"
};
module.exports = ___CSS_LOADER_EXPORT___;
